<template>
  <div class="base-page-container">
    <Top class="base-page-top-banner"></Top>
    <div class="base-page-main">
      <div class="base-page-header">
        <div class="base-page-year">
          {{
            meetInfo?.meet_info?.meet_start_time
              ? $tools.getDate(meetInfo?.meet_info?.meet_start_time, "yyyy")
              : "待定"
          }}
        </div>
        <div class="base-page-line"></div>
        <img
          class="base-page-edit"
          @click="editMeetInfo"
          :src="require(`@/assets/images/icon/edit.png`)"
          alt=""
        />
      </div>
      <div class="base-page-content">
        <div class="base-page-date">
          {{
            meetInfo?.meet_info?.meet_start_time
              ? $tools.getDate(meetInfo?.meet_info?.meet_start_time, "MM/dd")
              : "待定"
          }}
        </div>
        <div class="base-page-block">
          <div class="base-page-item">
            <img
              :src="require(`@/assets/images/icon/clock.png`)"
              class="base-page-item-icon"
            />
            <div class="base-page-item-info">
              {{
                meetInfo?.meet_info?.meet_start_time
                  ? $tools.getDate(
                      meetInfo?.meet_info?.meet_start_time,
                      "hh:mm"
                    )
                  : "待定"
              }}-
              {{
                meetInfo?.meet_info?.meet_start_time
                  ? $tools.getDate(meetInfo?.meet_info?.meet_end_time, "hh:mm")
                  : "待定"
              }}
            </div>
          </div>
          <div class="base-page-item" style="margin-top: 0.4rem">
            <div
              class="base-page-item-info"
              :style="`color:${meetStatusColor}`"
            >
              {{ getMeetStatus() }}
            </div>
          </div>
        </div>
      </div>
      <div class="base-page-title">
        <span>会议主题：</span>
        <span>{{ meetInfo.meet_info?.meet_name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import MyDialog from "@/components/unit/dialog/index.js";
import Top from "./top.vue";
import login from "./login";
export default {
  name: "basePage",
  mixins: [login],
  props: {
    meetInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      meetStatus: {
        0: "会议筹备中",
        1: "超时未召开",
        2: "会议待召开",
        3: "进行中",
        4: "协议签署中",
        5: "超时未召开",
      }, //会议状态
      payStatusArr: {
        0: "劳务支付中",
        1: "支付已完成",
        2: "支付未成功",
      },
      meetAuditStatus: {
        //会议审核状态
        0: "待审核",
        10: "会议审核中",
        // 20: '审核成功',
        30: "审核未通过",
        40: "协议签署中",
        50: "协议已签署",
      },
      uniqueDoctorArr: [],
      payStatus: 0,
      meetStatusColor: "#1ba747",
    };
  },
  components: {
    Top,
  },
  created() {
    console.log(this.meetInfo);
  },
  methods: {
    async editMeetInfo() {
      if (this.meetInfo.meet_info.status >= 3) {
        let text =
          this.meetInfo.meet_info.status >= 4 ? "会议已结束" : "会议进行中";
        this.$tips.error({ text: `${text},暂不能修改` });
        return;
      }
      try {
        await this.login();
      } catch (err) {
        console.log(err);
        return;
      }
      MyDialog({
        link: "/page/meet/components/basicInfo.vue",
        query: this.$route.query,
        meetInfo: this.meetInfo,
      })
        .then((res) => {
          this.$emit("updateMeetInfo");
          this.$tips.success({ text: "修改成功" });
        })
        .catch(() => {
          console.log(0);
        });
    },
    getMeetStatus() {
      //1、超时未召开（红色）---不管会议资料是否已完善，会议时间过了，没有召开的，都叫超时未召开
      if (
        (new Date(this.meetInfo.meet_info?.meet_end_time) < new Date() &&
          this.meetInfo.meet_info?.status == 2) ||
        this.meetInfo.meet_info?.status == 5
      ) {
        this.meetStatusColor = "#af0000";
        return "超时未召开";
      }
      //2、会议筹备中（绿色）----还有专家信息未确认的情况
      let tempDoctorArr =
        this.meetInfo.meet_link?.filter((item) => item.name == "待定") || [];
      if (tempDoctorArr.length > 0) {
        this.meetStatusColor = "#1ba747";
        return "会议筹备中";
      }
      //3、资料完善中（绿色）----还有专家信息未完善的情况
      tempDoctorArr =
        this.meetInfo.meet_link?.filter((item) => item.is_finish == 0) || [];
      if (tempDoctorArr.length > 0) {
        this.meetStatusColor = "#1ba747";
        return "资料完善中";
      }
      //4、会议待召开（绿色）----所有的会议相关信息均已完善，但是未到会议召开时间
      if (new Date(this.meetInfo.meet_info?.meet_start_time) > new Date()) {
        this.meetStatusColor = "#1ba747";
        return "会议待召开";
      }
      if (this.uniqueDoctorArr.length == 0 && this.meetInfo.meet_link) {
        //医生列表用ID去重
        this.uniqueDoctorArr = [
          ...new Map(
            this.meetInfo.meet_link.map((item) => [item.doctor_id, item])
          ).values(),
        ];
        let payStatusArr = this.uniqueDoctorArr.map((item) => item.pay_status);
        //有一个医生未支付，则支付状态为支付中
        if (payStatusArr.includes(0)) {
          this.payStatus = 0;
        } else if (payStatusArr.includes(1)) {
          //没有医生未支付且有一个医生支付成功，则支付状态为支付完成
          this.payStatus = 1;
        } else {
          //没有医生未支付且所有医生支付失败，则支付状态为支付失败
          this.payStatus = 2;
          this.meetStatusColor = "#af0000";
        }
      }
      if (this.meetInfo.meet_info.status != 4) {
        //会议未召开显示会议状态
        return this.meetStatus[this.meetInfo.meet_info.status];
      } else if (
        this.meetInfo.meet_info.status == 4 &&
        this.meetInfo.meet_info.audit_status <= 40
      ) {
        //会议已召开未审核完成显示审核状态
        let text = this.meetAuditStatus[this.meetInfo.meet_info.audit_status];
        if (this.meetInfo.meet_info.audit_status == 40) {
          //已签署协议医生数量
          let signDoctor = this.uniqueDoctorArr.filter(
            (item) => item.sign_status == 1
          );
          text =
            signDoctor.length < this.uniqueDoctorArr.length
              ? `${text}（${signDoctor.length}/${this.uniqueDoctorArr.length}）`
              : text;
          this.meetStatusColor =
            signDoctor.length < this.uniqueDoctorArr.length
              ? "#af0000"
              : "#1ba747";
        }
        return text;
      } else {
        //会议已召开且审核完成显示支付状态
        let text = this.payStatusArr[this.payStatus];
        //支付失败的医生
        let payFailedArr = this.uniqueDoctorArr.filter(
          (item) => item.pay_status == 2
        );
        text =
          this.payStatus != 2 && payFailedArr.length
            ? `${text}（${payFailedArr.map((x) => x.name).join("、")}支付失败）`
            : text;
        this.meetStatusColor = payFailedArr.length ? "#af0000" : "#1ba747";
        return text;
      }
    },
  },
};
</script>

<style scoped>
.base-page-container {
  display: flex;
  color: #231815;
  font-size: 13px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
  background: #fff;
  margin: 0 13px;
  width: calc(100% - 26px);
}

.base-page-top-banner {
  flex: 4.5px 0 0;
  height: auto;
}

.base-page-main {
  flex: 1 0 0;
  padding: 15px 10px;
}

.base-page-header {
  display: flex;
  align-items: center;
  width: 100%;
}

.base-page-year {
}

.base-page-line {
  background: rbga(0, 0, 0, 0.06);
  flex: 1 0 0;
  height: 1px;
  margin: 0 10px;
  background: #dcdcdc;
}

.base-page-edit {
  height: 18px;
  width: auto;
}

.base-page-content {
  display: flex;
  padding: 12px 0;
}

.base-page-date {
  font-size: 52px;
  line-height: 52px;
  color: var(--el-color-primary);
  margin-right: 16px;
}
.base-page-block {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4px 0;
}

.base-page-item {
  display: flex;
}

.base-page-item-icon {
  height: 13px;
  width: 13px;
  margin-right: 6px;
}

.base-page-item-info {
}
.base-page-title {
  /* font-weight: 400; */
}
</style>
